<div>Version: {{ environment }} {{ version }} ({{ releaseVersionDate }})</div>
